import type { ReactNode } from "react";
import { CompareValueBarChart } from "./CompareValueBarChart";
import { fitDomain, measuredSeries } from "./evalCompareChartModel";
import type { EvalResultSeries } from "./evalCompareModel";
import { formatPercentStat } from "./evalCompareSummaryModel";

export function KpiCompareChart({ items }: { items: readonly EvalResultSeries[] }): ReactNode {
  // 성공률이 없는 시리즈는 막대를 그리지 않는다. null 을 0% 로 그리면 "항상 실패"로 읽힌다.
  const measured = measuredSeries(items, (summary) => summary.finalSuccessRate);
  return (
    <CompareValueBarChart
      title="최종 성공률"
      items={measured}
      value={(item) => item.summary.finalSuccessRate ?? 0}
      format={formatPercentStat}
      domain={fitDomain}
      yAxisWidth={44}
      tickOffset={12}
    />
  );
}
